import * as progressCategories from './progressCategories';

export const FIRST_QUESTION_ROUTE = '/consultation/my-hair/age';
export const RETURNING_CONSULTATION_ROUTE = '/consultation?is-returning=true';
export const FINAL_ROUTE = '/consultation/results/get-results';
export const SUPPLEMENT_FINAL_ROUTE = '/supplements-consultation/results/get-results';

export const MY_HAIR = 'my-hair';
export const MY_TREATMENTS = 'my-treatments';
export const MY_LIFESTYLE = 'my-lifestyle';
export const MY_PREFERENCES = 'my-preferences';
export const MY_GOALS = 'my-goals';
export const RESULTS = 'results';

export const progressTrackerCategories = [
  {
    code: progressCategories.HAIR_SCALP,
    label: 'Hair & Scalp',
  },
  {
    code: progressCategories.TREATMENTS,
    label: 'Treatments',
  },
  {
    code: progressCategories.LIFESTYLE,
    label: 'Lifestyle',
  },
  {
    code: progressCategories.PREFERENCES_GOALS,
    label: 'Preferences & Goals',
    labelMobile: 'Preferences',
  },
];

// if need to go to oil cart
// export const URL_CART_OIL = '/checkout?origin=oil';
